import { defineComponent as _defineComponent } from 'vue'
import CarouselArrowButton from 'JS/components/carousels/CarouselArrowButton.vue';
import CatapultBannerProductCard from './CatapultBannerProductCard.vue';
import VIntersectionObserver from 'JS/components/VIntersectionObserver.vue';
import { CarouselType } from "JS/types/Carousel";
import { computed, ref, watch } from 'vue';
import { createPromoDataAttributes } from 'JS/utilities/analytics';
import { getPriceMode } from 'JS/types/Product';
import { ICatapultBanner } from '../sponsored-types';
import { IProductCarouselProduct } from 'Src/js/types/Carousel';
import { useProductCarouselTracking } from 'JS/dxp/composables/product-carousel-tracking';
import { useViewportWidth } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'CatapultBanner',
  props: {
    catapultBanner: null
  },
  setup(__props: any) {

const props = __props as {
	catapultBanner: ICatapultBanner;
}



const isLargeScreen = ref(true);

const gaDataAttributes = computed(() => createPromoDataAttributes({
	promoId: props.catapultBanner.ctaLink?.replace("https://www.farmandfleet.com", "") ?? 'EpsilonCatapultAdNoCTA',
	creativeSlot: `sponsored-catapult-banner`,
	creativeName: `sponsored-catapult-banner_${props.catapultBanner.adId}`,
	promoName: `${props.catapultBanner.headerText}`
}));

const isNotCarousel = computed(() => {
	return isLargeScreen.value && props.catapultBanner.sponsoredProducts?.length == 3;
});

function trackClickHelper(product: IProductCarouselProduct, idx: number) {
	recordBannerClick();
	trackClick({ ...product, brand: product.vendorBrand }, idx);
}

const { trackView, trackClick } = useProductCarouselTracking(() => {

	return {
		type: CarouselType.CATAPULT_BANNER,
		name: 'Catapult Banner',
		products: props.catapultBanner.sponsoredProducts.map(product => ({
			blainNumber: product.blainNumber,
			vendorBrand: product.vendorBrand,
			productName: product.productName,
			price: product.price,
			belowMap: product.price.isBelowMAP,
			priceMode: getPriceMode(product.price)
		})),
	};
});

function recordImpression() {
	trackView();
	navigator.sendBeacon('/event/a/sponsored-ad-impression', JSON.stringify([props.catapultBanner.adId]));
}

function recordBannerClick() {
	navigator.sendBeacon('/event/a/sponsored-ad-click', JSON.stringify(props.catapultBanner.adId));
}

const viewportWidth = useViewportWidth();
watch(() => viewportWidth.value, () => {
	if (viewportWidth.value > 1403) {
		isLargeScreen.value = true;
	} else {
		isLargeScreen.value = false;
	}
}, { immediate: true });


return { __sfc: true,props, isLargeScreen, gaDataAttributes, isNotCarousel, trackClickHelper, trackView, trackClick, recordImpression, recordBannerClick, viewportWidth, CarouselArrowButton, CatapultBannerProductCard, VIntersectionObserver }
}

})